export type FooterNavItem = {
    labelKey: string;
    href: string;
    external?: boolean;
};

export type FooterNavGroup = {
    titleKey: string;
    items: FooterNavItem[];
};

export const sitemapGroup: FooterNavGroup = {
    titleKey: 'Footer.nav.sitemap.title',
    items: [
        { labelKey: 'Footer.nav.sitemap.items.home', href: '/' },
        { labelKey: 'Footer.nav.sitemap.items.tracking', href: '/cargo' },
        { labelKey: 'Footer.nav.sitemap.items.company', href: '/company' },
        { labelKey: 'Footer.nav.sitemap.items.services', href: '/services' },
        { labelKey: 'Footer.nav.sitemap.items.faq', href: '/services/faq' },
        { labelKey: 'Footer.nav.sitemap.items.contacts', href: '/contacts' },
        { labelKey: 'Footer.nav.sitemap.items.autosales', href: '/gg-autosales' },
        { labelKey: 'Footer.nav.sitemap.items.customerZone', href: '/customer' },
    ],
};

export const locationsGroup: FooterNavGroup = {
    titleKey: 'Footer.nav.locations.title',
    items: [
        { labelKey: 'Footer.nav.locations.items.savannah', href: `/contacts/customer-service#savannah` },
        { labelKey: 'Footer.nav.locations.items.newYork', href: `/contacts/customer-service#new-york` },
        { labelKey: 'Footer.nav.locations.items.losAngeles', href: `/contacts/customer-service#los-angeles` },
        { labelKey: 'Footer.nav.locations.items.houston', href: `/contacts/customer-service#houston` },
        { labelKey: 'Footer.nav.locations.items.seattle', href: `/contacts/customer-service#tacoma` },
        { labelKey: 'Footer.nav.locations.items.norfolk', href: `/contacts/customer-service#norfolk` },
    ],
};

export const legalLinks: FooterNavItem[] = [{ labelKey: 'Footer.legal.terms', href: '#' }];
